import { ISubject } from 'utils/data/subjectList'
import { RootState } from 'modules'

export const selectSubjectMenu = (state: RootState): Array<ISubject> | null =>
  state.subjectMenu
